module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/bg-pattern-56557f12996aad970d261ba65e58b92b.svg";